export default "__VITE_ASSET__e56a11fa__"